module.exports = __webpack_public_path__ + "static/assets/059128109f4c99fd85668e22fefb7b4f.png";